// src/components/CourseDetail.jsx
import { useParams } from 'react-router-dom';
import PythonDetail from './PythonDetail';
import PhpDetail from './PhpDetail';
import SQLDetail from './SQLDetail';
import VMware7Detail from './VMware7Detail';
import PythonDataAnalysisDetail from './PythonDataAnalysisDetail';
import RedHatSystemAdministrationIDetail from './RedHatSystemAdministrationIDetail';
import RedHatSystemAdministrationIIDetail from './RedHatSystemAdministrationIIDetail';
import HtmlJavascriptDetail from './HtmlJavascriptDetail';
import MongoDBDetail from './MongoDBDetail';
import InformationSecurityProgramsDetail from './InformationSecurityProgramsDetail';
import AdvancedEthicalHackingDetail from './AdvancedEthicalHackingDetail';
import DevOpsWithAWSDetail from './DevOpsWithAWSDetail';
import DevOpsTrainingDetail from './DevOpsTrainingDetail';
import DataScienceAndMLWithPythonDetail from './DataScienceAndMLWithPythonDetail';
import CybersecurityAnalystFundamentalsToAdvancedDetail from './CybersecurityAnalystFundamentalsToAdvancedDetail';
import DataVisualizationWithPowerBIDetail from './DataVisualizationWithPowerBIDetail';
import AWSDataScienceDetail from './AWSDataScienceDetail';
import DatabaseProgrammingWithPLSQLDetail from './DatabaseProgrammingWithLLSQLDetail';
import ApacheCassandraDetail from './ApacheCassandraDetail';
import IFSTechnicalDevelopmentDetail from './IFSTechnicalDevelopmentDetail';
import FinancialsSupplyChainManagementDetail from './FinancialsSupplyChainManagementDetail';
import DigitalMarketingDetail from './DigitalmarketingDetail';
import AbapDetail from './AbapDetail';
import AbapOnHanaDetail from './AbapOnHanaDetail';
import SapMmDetail from './SapMmDetail';
import S4HanaFinanceDetail from './S4HanaFinanceDetail';
import SuccessFactorsDetail from './SuccessFactorsDetail';
import SapGrcDetail from './SapGrcDetail';
import SapHcmDetail from './SapHcmDetail';
import SapSecurityDetail from './SapSecurity';
import SapSdDetail from './SapSdDetails';
import SapS4HanaMmDetail from './SapS4HanaMmDetail';

const CourseDetail = () => {
  const { courseName } = useParams();

  switch (courseName) {
    case 'python':
      return <PythonDetail />;
    case 'php':
      return <PhpDetail />;
    case 'sql':
      return <SQLDetail />;
    case 'vmware7':
      return <VMware7Detail />;
    case 'pythonDataAnalysis':
      return <PythonDataAnalysisDetail />;
    case 'redHatSystemAdministrationI':
      return <RedHatSystemAdministrationIDetail/>;
    case 'redHatSystemAdministrationII':
      return <RedHatSystemAdministrationIIDetail />;
    case 'htmlAndJavaScript':
      return <HtmlJavascriptDetail />;
    case 'mongoDB':
      return <MongoDBDetail/>;
    case 'informationSecurityPrograms' :
      return <InformationSecurityProgramsDetail/>
    case 'advancedEthicalHacking':
      return <AdvancedEthicalHackingDetail/>
    case 'devOpsWithAWS':
      return <DevOpsWithAWSDetail/>  
    case 'devOpsTraining':
      return <DevOpsTrainingDetail/>
    case 'dataScienceAndMLWithPython':
      return <DataScienceAndMLWithPythonDetail/> 
    case 'cybersecurityAnalystFundamentalsToAdvanced'  :   
      return <CybersecurityAnalystFundamentalsToAdvancedDetail/>
    case 'dataVisualizationWithPowerBI':
      return <DataVisualizationWithPowerBIDetail/>  
    case 'awsDataScience':
      return <AWSDataScienceDetail/>  
    case 'databaseProgrammingWithPLSQL':
      return <DatabaseProgrammingWithPLSQLDetail/>
    case 'apacheCassandra':
      return <ApacheCassandraDetail/>
    case 'ifsTechnicalDevelopment':
     return <IFSTechnicalDevelopmentDetail/> 
    case 'financialsSupplyChainManagement':
      return <FinancialsSupplyChainManagementDetail/>  
    case 'digitalMarketing':
      return <DigitalMarketingDetail/> 
    case 'abap':
      return <AbapDetail/>   
    case 'abapOnHana':
      return <AbapOnHanaDetail/>  
    case 'sapS4HanaMm': 
      return <SapS4HanaMmDetail/>
    case 's4HanaFinance':  
      return <S4HanaFinanceDetail/>
    case 'successFactors':
      return <SuccessFactorsDetail/>  
    case 'sapGrc':
      return <SapGrcDetail/>  
    case 'sapHcm':
      return <SapHcmDetail/>  
    case 'sapSecurity':
      return <SapSecurityDetail/>  
    case 'sapSd':
      return <SapSdDetail/> 
    case 'sapMm': 
      return <SapMmDetail/> 
    default:
      return <div>Course not found</div>;
  }
};

export default CourseDetail;
